export function identity<T>(x: T): T {
  return x
}
